import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestNews from './components/LatestNews';
import PatchNotePreview from './components/PatchNotePreview';
import NewsletterCTA from './components/NewsletterCTA';
import SEOHead, { SITE_URL } from '../../components/feature/SEOHead';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'CallOfDutyNext.com',
    url: SITE_URL,
    description:
      'Your #1 source for Call of Duty news, patch notes, Warzone updates, and CDL esports coverage.',
    publisher: { '@type': 'Organization', name: 'CallOfDutyNext.com' },
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/news?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'CallOfDutyNext.com',
    url: SITE_URL,
    logo: `${SITE_URL}/favicon.ico`,
    sameAs: ['https://twitter.com/CallOfDutyNext'],
    description:
      'CallOfDutyNext.com — The #1 independent Call of Duty news site. Covering Warzone, Multiplayer, Zombies, patch notes, and CDL esports.',
  },
];

export default function HomePage() {
  return (
    <div className="bg-[#111] min-h-screen">
      <SEOHead
        title="Call of Duty Next #1 Call of Duty News, Updates"
        description="CallOfDutyNext.com is your #1 source for Call of Duty news, patch notes, weapon tier lists, Warzone updates, and CDL esports coverage. Breaking CoD intel updated 24/7."
        keywords="Call of Duty, Warzone, patch notes, CoD news, multiplayer, Zombies, CDL esports"
        canonical="/"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <LatestNews />
        <PatchNotePreview />
        <NewsletterCTA />
      </main>
      <Footer />
    </div>
  );
}
